import React from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import LoginForm from "../../components/auth/LoginForm";
import logo from "../../assets/logo.png";
import pkg from "../../../package.json";
import { marketingUrl } from "../../site/siteConfig";
import "./AuthPages.css";

const { version } = pkg;

export default function LoginPage() {
  const navigate = useNavigate();
  // Set by ProtectedRoute when a signed-out user opened a protected page (for
  // example the AI assistant consent screen); otherwise go home as before.
  const from = useLocation().state?.from;
  const next = from ? `${from.pathname}${from.search || ""}` : "/";

  return (
    <div className="auth-shell">
      <section className="auth-main">
        <div className="auth-container">
          <div className="auth-header">
            <img src={logo} alt="DecisionFlow" className="auth-logo" />
            <h1>Welcome Back</h1>
            <p>
              Sign in to access your workspace and manage workflows, projects,
              users, and permissions.
            </p>
          </div>
          <LoginForm onSuccess={() => navigate(next)} />
          <div className="auth-links">
            <Link to="/forgot-password">Forgot password?</Link>
            <span>-</span>
            <Link to="/register-company">Create account</Link>
          </div>
        </div>
        <div className="auth-footer">
          <div className="auth-footer-links">
            <a href={marketingUrl("/")}>DecisionFlow.in</a>
            <span>·</span>
            <a href={marketingUrl("/support")}>Support</a>
            <span>·</span>
            <a href={marketingUrl("/privacy")}>Privacy Policy</a>
          </div>
          <p className="auth-copyright">v{version}</p>
        </div>
      </section>
      <aside className="auth-side">
        <h2>DecisionFlow</h2>
        <p>
          Build workflows, manage projects, and control access - all in one
          workspace.
        </p>
      </aside>
    </div>
  );
}
